export default "/fonts/Flaticon2.ttf?41914745046d0478cead813ef1a0c614";